import { ActionTree } from "vuex";
import { IExpeditionState } from "./state";
import {
    IExpedition,
    IExpeditionDay,
    IExpeditionAutoControl,
    IExpeditionNotification,
    IExpeditionFill,
    ISlot,
} from "@/models";
import { AxiosResponse } from "axios";
import { apiClient } from "@/services";
import {
    ADD_EXPEDITION_DAY,
    ADD_NOTIFICATIONS,
    SET_SELECTED_EXPEDITION,
    ADD_AUTOCONTROL_PICTURE,
    ADD_ENDLOAD_PICTURE,
    REMOVE_AUTOCONTROL_PICTURE,
    REMOVE_ENDLOAD_PICTURE,
    SET_EXPEDITION_AUTOCONTROL,
    SET_SELECTED_NOTIFICATION,
    CLEAN_EXPEDITION,
    SET_EXPEDITION_START_SLOT,
    SET_EXPEDITION_END_SLOT,
} from "./mutations-types";

export const actions: ActionTree<IExpeditionState, number> = {
    async fetchExpeditionsDay(context, data: any): Promise<AxiosResponse<IExpeditionDay>> {
        const response = await apiClient.get<IExpeditionDay>(`/expeditions?day=${data}`);
        context.commit(ADD_EXPEDITION_DAY, response.data);

        return response;
    },

    async fetchNotifications(context): Promise<AxiosResponse<IExpeditionNotification[]>> {
        const response = await apiClient.get<IExpeditionNotification[]>(`/expeditions/notifications`);
        context.commit(ADD_NOTIFICATIONS, response.data);

        return response;
    },

    async addExpedition(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post(`/expeditions`, data);
        return response;
    },

    addAutoControlPicture(context, data: string) {
        context.commit(ADD_AUTOCONTROL_PICTURE, data);
    },

    addEndLoadPicture(context, data: string) {
        context.commit(ADD_ENDLOAD_PICTURE, data);
    },

    removeAutoControlPicture(context, data: number) {
        context.commit(REMOVE_AUTOCONTROL_PICTURE, data);
    },

    removeEndLoadPicture(context, data: number) {
        context.commit(REMOVE_ENDLOAD_PICTURE, data);
    },

    setSelectedExpedition(context, data: IExpedition): void {
        context.commit(SET_SELECTED_EXPEDITION, data);
    },

    setExpeditionAutoControl(context, data: IExpeditionAutoControl): void {
        context.commit(SET_EXPEDITION_AUTOCONTROL, data);
    },

    async validateExpedition(context, data: any): Promise<AxiosResponse<void>> {
        const payload = {
            expedition: context.getters.getSelectedExpedition(),
            expeditionAutoControl: context.getters.getExpeditionAutoControl(),
            autoControlPictures: context.getters.getAutoControlPictures(),
            endLoadPictures: context.getters.getEndLoadPictures(),
            incompletePallets: data.incompletePallets,
            totalPallet: data.totalPallet,
        };

        const response = await apiClient.post<void>(`/expeditions/validate`, payload);

        context.commit(CLEAN_EXPEDITION);

        return response;
    },

    setSelectedNotification(context, data: IExpeditionNotification): void {
        context.commit(SET_SELECTED_NOTIFICATION, data);
    },

    async editExpedition(context, data: IExpedition): Promise<AxiosResponse<void>> {
        const response = await apiClient.put<void>(`expeditions/${data.expeditionId}`, data);
        return response;
    },

    async initExpedition(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/expeditions/init`, data);

        return response;
    },

    async fillExpedition(context, data: IExpeditionFill): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/expeditions/fill`, data);

        return response;
    },

    async deleteExpedition(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post(`/expeditions/delete/${data.expeditionId}`, { deleteComment: data.deleteComment });

        return response;
    },

    async addAskAppointment(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post(`expeditions/ask`, data);

        return response;
    },

    async finalValidation(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post("expeditions/finalValidation", data);

        return response;
    },

    async exportExpeditions(context): Promise<AxiosResponse<void>> {
        const response = await apiClient.get(`/expeditions/export`, { responseType: "blob" });
        return response;
    },

    async fetchExpeditionStartSlot(context): Promise<AxiosResponse<ISlot>> {
        const response = await apiClient.get<ISlot>("/slots/ExpeditionStartSlot");
        context.commit(SET_EXPEDITION_START_SLOT, response.data);

        return response;
    },

    async fetchExpeditionEndSlot(context): Promise<AxiosResponse<ISlot>> {
        const response = await apiClient.get<ISlot>("/slots/ExpeditionEndSlot");
        context.commit(SET_EXPEDITION_END_SLOT, response.data);

        return response;
    },

    async updateExpeditionSlots(context, data: any): Promise<AxiosResponse< void>> {
        const response = await apiClient.post<void>(`/slots/UpdateExpeditionSlots/${data.startSlotId}/${data.endSlotId}`);
        return response;
    },
};
